export default {
  to: "/dashboard/application-list",
  order: 2,
  icon: "mdi-file-document-edit-outline",
  title: "Applications",
  sublinks: [
    {
      to: `/dashboard/application/list`,
      order: 1,
      title: "My Applications",
      disabled: false,
      icon: "mdi-text-box-search-outline",
    },
    {
      to: `/dashboard/application/reports`,
      order: 2,
      title: "Reports",
      disabled: false,
      icon: "mdi-chart-areaspline",
    },
  ],
};
